import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ChargedActModel} from '../chargedAct.model';
import {SaleSummaryConverter} from '../../../../../sale/api/entity/converter/saleSummary.converter';
import {
    ConsultationSummaryConverter
} from '../../../../consultation/consultation/api/model/converter/consultationSummary.converter';

@Injectable({ providedIn: 'root' })
export class ChargedActConverter extends HttpModelConverter<ChargedActModel> {

    public constructor(private converter: ConsultationSummaryConverter,
                       private saleSummaryConverter: SaleSummaryConverter) {
        super();
    }

    protected createInstance(): ChargedActModel {
        return new ChargedActModel();
    }

    protected enrichObject(result: ChargedActModel, src: ChargedActModel) {
        result.sale = this.saleSummaryConverter.convert(src.sale);
        result.consultation = this.converter.convert(src.consultation);
    }

}
